var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 4C20.9926 4 22 5.00736 22 6.25V17.7546C22 18.9972 20.9926 20.0046 19.75 20.0046H4.25C3.00736 20.0046 2 18.9972 2 17.7546V6.25C2 5.00736 3.00736 4 4.25 4H19.75ZM9.75 12.5H6.25C5.8703 12.5 5.55651 12.7822 5.50685 13.1482L5.5 13.25V13.7418L5.50787 13.8501C5.67048 14.9637 6.60213 15.5009 7.99995 15.5009C9.33112 15.5009 10.2395 15.0141 10.4637 14.0064L10.4921 13.8513L10.5 13.7427V13.25C10.5 12.8703 10.2178 12.5565 9.85177 12.5068L9.75 12.5ZM17.75 12.9961H13.2523L13.1505 13.003C12.7844 13.0526 12.5023 13.3664 12.5023 13.7461C12.5023 14.1258 12.7844 14.4396 13.1505 14.4893L13.2523 14.4961H17.75L17.8518 14.4893C18.2178 14.4396 18.5 14.1258 18.5 13.7461C18.5 13.3664 18.2178 13.0526 17.8518 13.003L17.75 12.9961ZM8 8.50218C7.17159 8.50218 6.50003 9.17374 6.50003 10.0022C6.50003 10.8306 7.17159 11.5021 8 11.5021C8.82841 11.5021 9.49997 10.8306 9.49997 10.0022C9.49997 9.17374 8.82841 8.50218 8 8.50218ZM17.75 9.5H13.2523L13.1505 9.50685C12.7844 9.55651 12.5023 9.8703 12.5023 10.25C12.5023 10.6297 12.7844 10.9435 13.1505 10.9932L13.2523 11H17.75L17.8518 10.9932C18.2178 10.9435 18.5 10.6297 18.5 10.25C18.5 9.8703 18.2178 9.55651 17.8518 9.50685L17.75 9.5Z",
    fill: "#605E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.d9dd9be399afc663e4b08dd24e9c0ead.svg";
export { ForwardRef as ReactComponent };